// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"157789a7","239":"6123aa14","455":"c71fe43c"}[chunkId] + ".chunk.js";
};